import { Caption } from '@liveauctioneers/hammer-ui-core/text';
import { useEffect, useState } from 'react';

import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogIsTimedPlusBiddingOpen,
    getCatalogIsTimedPlusClosing,
    getCatalogStartTime,
    getCatalogTimedPlusBiddingEndsFromTs,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { longFormatDate } from '@/utils/dates';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    catalogId: number;
};

export const CatalogCardTimedPlusDate = ({ catalogId }: Props) => {
    const isOpen = useAppSelector((state) => getCatalogIsTimedPlusBiddingOpen(state, catalogId));
    const isClosing = useAppSelector((state) => getCatalogIsTimedPlusClosing(state, catalogId));
    const startTime = useAppSelector((state) => getCatalogStartTime(state, catalogId));
    const endsFromTime = useAppSelector((state) => getCatalogTimedPlusBiddingEndsFromTs(state, catalogId));
    const formatMessage = useAppFormatMessage();

    const [saleStartDate, setSaleStarDate] = useState('');
    const [saleEndDate, setSaleEndDate] = useState('');

    useEffect(() => {
        setSaleStarDate(longFormatDate(startTime));
        setSaleEndDate(longFormatDate(endsFromTime));
    }, [startTime, endsFromTime]);

    if (isClosing) {
        return (
            <div className="flex flex-col items-start justify-center">
                <Caption
                    className="block"
                    color="secondary"
                >
                    {formatMessage(['catalogPage', 'catalogDate', 'endingNow'])}
                </Caption>
            </div>
        );
    }
    if (isOpen) {
        return (
            <div className="flex flex-col items-start justify-center">
                <Caption
                    className="block"
                    color="secondary"
                    suppressHydrationWarning
                >
                    {formatMessage(['catalogPage', 'catalogDate', 'endsFrom'], { values: { date: saleEndDate } })}
                </Caption>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-start justify-center">
            <Caption
                className="block"
                color="secondary"
            >
                {formatMessage(['catalogPage', 'catalogDate', 'startsOn'], { values: { date: saleStartDate } })}
            </Caption>
        </div>
    );
};
